import gql from 'graphql-tag';

const CLUBS_CONFERENCE_ATTENDANCE_SET = gql`
mutation clubsConferenceAttendanceSet($input: ClubsConferenceAttendanceSetInput!) {
	clubsConferenceAttendanceSet (input: $input)
}
`;

export default CLUBS_CONFERENCE_ATTENDANCE_SET;
